import { forwardRef, type Ref, type SVGProps } from "react";
const IconHospitalFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14m-3-7a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v4h-4v-4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHospitalFilledSVG);
ForwardRef.displayName = "IconHospitalFilled";
export { ForwardRef as IconHospitalFilled };
